export const AVAILABLE_VIEWPORT_FRACTION_FOR_TOOLBAR = 0.75;
export const TOOLBAR_COLLAPSED_SIZE = 72;
export const TOOLBAR_EXPANDED_SIZE = 420;
